import { InjectionToken } from '@angular/core';

export interface FacebookPixelConfig {
  enabled: boolean;
  pixelId: string;
}

export const FACEBOOK_PIXEL_CONFIG = new InjectionToken<FacebookPixelConfig>('FacebookPixelConfig');
